import { Box, Card, CardActions, CardContent } from '@mui/material';
import '../styles/UploadPage.css';
import img1 from '../../../img/photo_selection_1.png';
import img2 from '../../../img/photo_selection_2.png';
import SelectPhotoButton from '../../../shared/components/ui/buttons/SelectPhotoButton';
import selectPhotoButton_img1 from '../../../img/select_photo_button.png'; // 写真を撮る選ぶアイコン
import ViewAllButton from '../../../shared/components/ui/buttons/ViewAllButton';

const PhotoSelection = () => {
    return (
        <Box className="section">
            <Card
                className="upload-card"
                sx={{
                    bgcolor: 'rgba(255, 255, 255, 0.5)', // カードの背景色
                    boxShadow: 'none',
                    color: 'rgb(100, 90, 70)',
                }}
            >
                <CardContent
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        padding: '8px',
                    }}
                >
                    <p className='title'>How to use?</p>
                    <p className='process'>1.下のボタンをクリックし、</p>
                    <p className='process'>写真を撮るか、アルバムから写真を選択します</p>
                    <img src={img1} alt='sample-img' style={{ width: '90%', aspectRatio: '5 / 2' }}/>
                    <p className='process'>2.画面に向けて写真をスワイプします</p>
                    <img src={img2} alt='sample-img' style={{ width: '30%', aspectRatio: '2 / 2', paddingLeft: '25px' }}/>
                </CardContent>
                
                <CardActions
                    sx={{
                        padding: '8px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <SelectPhotoButton imageUrl={selectPhotoButton_img1}/>
                </CardActions>
                
                <CardContent
                    sx={{
                        padding: '0px 8px 0px 8px',
                    }}
                >
                    <p className='attention'>※アップロードされた写真は結婚式場のスクリーン表示のみに使用され、無断転用はいたしません。事務局側の判断により画像が削除される場合がございますのでご承知おきください。</p>
                </CardContent>
            </Card>
            <CardActions>
                <ViewAllButton/>
            </CardActions>
        </Box>
    )
}

export default PhotoSelection;
